var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-stretch"},[_c('div',{staticClass:"d-flex justify-space-around"},_vm._l((_vm.number),function(x){return _c('div',{staticClass:"ma-4 mb-4"},[_c('div',{staticClass:"number"},[_vm._v(_vm._s(x))]),_c('v-divider')],1)}),0),_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }